import React from "react";
import Modal from "react-bootstrap/Modal";
import { ExternalLink } from "lucide-react";
import { elakayAutoText } from "../dataElakay";
import { isImageUrl } from "./jobApplicationFormat";
import "../../pages/jobDashboard.css";
import "./JobDocumentPreviewModal.css";
import { toFileUrl } from "../../../utils/fileUrl";

// In-app preview for a job-related link/document (CV, resume, portfolio,
// LinkedIn, custom social links, attached documents): images render inline,
// everything else renders in an iframe with an "open in a new tab" fallback
// (some sites, e.g. LinkedIn, block being framed -- see the note below).
// Extracted from jobApplicationsAdmin.jsx's original inline preview block so
// every screen that shows a candidate's documents (jobDashboard.jsx's
// applicant modal, /my-job-applications, jobApplicationsAdmin.jsx) shares
// the exact same "stay on the page, never open a new tab" behavior instead
// of three divergent copies.
const JobDocumentPreviewModal = ({ item, onClose }) => {
  if (!item) return null;

  return (
    <Modal show size="xl" centered onHide={onClose} dialogClassName="job-admin-modal">
      <button type="button" className="job-admin-modal-close" onClick={onClose} aria-label={elakayAutoText("h_bbfa773e5a63a5", "Close")}>×</button>
      <Modal.Body>
        <div className="job-doc-preview-header">
          <h2>{item.title}</h2>
          {item.url && (
            <a className="job-admin-btn secondary" href={toFileUrl(item.url)} target="_blank" rel="noopener noreferrer">
              <ExternalLink size={14} />{elakayAutoText("h_jobappsadmin_open_newtab", "Ouvrir dans un nouvel onglet")}
            </a>
          )}
        </div>
        {item.url ? (
          isImageUrl(item.url) ? (
            <div className="job-doc-preview-frame">
              <img src={toFileUrl(item.url)} alt={item.title} className="job-doc-preview-image" />
            </div>
          ) : (
            <div className="job-doc-preview-frame">
              <iframe src={toFileUrl(item.url)} title={item.title} />
            </div>
          )
        ) : (
          <div className="job-admin-empty small">{elakayAutoText("h_jobapp_nodocs", "Aucun document joint.")}</div>
        )}
        <p className="job-doc-preview-note">
          {elakayAutoText(
            "h_jobappsadmin_preview_note",
            "Certains sites (ex: LinkedIn) bloquent l'affichage integre. Utilise le lien ci-dessus si la page reste vide."
          )}
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default JobDocumentPreviewModal;
